export default __webpack_public_path__ + "static/media/crown-third.9661b8db.svg";